import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './FilterSections.css';
import { StatusIndicator } from '../../../StatusIndicator';
import { SettingIndicator } from '../../../SettingIndicator';
import { DemandIndicator } from '../../../DemandIndicator';
import { ThermostatActions } from '../../../../store';
import { FilterRow } from '../FilterRow';
import {
  connectionState,
  mode,
  fanMode,
  demand,
  buildingSection,
  rowOne,
  rowTwo,
  rowThree,
  states,
} from '../../thermostatFilterConstants';

export class FilterSections extends Component {
  changeFilter = (e, key, id) => {
    const { checked } = e.target;
    const { thermostatFilters } = this.props;
    const updatedFilters = {
      ...thermostatFilters,
      [key]: {
        ...thermostatFilters[key],
        [id]: checked,
      },
    };
    this.props.updateFilters(updatedFilters);
  };

  toggleButton = (e, key) => {
    const { id } = e.target;

    const { thermostatFilters } = this.props;
    const updatedFilters = {
      ...thermostatFilters,
      [key]: {
        ...thermostatFilters[key],
        [id]: !thermostatFilters[key][id],
      },
    };

    this.props.updateFilters(updatedFilters);
  };

  calculatePercent(filterCount) {
    const { filteredThermostatCount = null } = this.props;
    return filteredThermostatCount ? `${((filterCount / filteredThermostatCount) * 100).toFixed()}%` : '';
  }

  renderConnectionState() {
    const { thermostatFilters = {} } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Connection State</div>
        <div>
          {connectionState.map((item, index) => {
            const { filter, filterDisplay } = item;
            const filterCount = this.props.thermostatFilterCounts.connection_state[filter];
            const percentage = this.calculatePercent(filterCount);
            const key = `${filter}${index}`;
            return (
              <FilterRow
                key={key}
                filter={filter}
                filterDisplay={filterDisplay}
                filterGroup="connection_state"
                filterCount={filterCount}
                onClick={this.changeFilter}
                checked={thermostatFilters.connection_state[filter] === true}
                percentage={percentage}
              >
                <StatusIndicator state={filter} />
              </FilterRow>
            );
          })}
        </div>
      </div>
    );
  }

  renderThermostatMode() {
    const { thermostatFilters } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Thermostat Mode</div>
        <div>
          {mode.map((item, index) => {
            const { filter, filterDisplay } = item;
            const filterCount = this.props.thermostatFilterCounts.mode[filter];
            const percentage = this.calculatePercent(filterCount);
            const key = `${filter}${index}`;
            return (
              <FilterRow
                key={key}
                filter={filter}
                filterDisplay={filterDisplay}
                filterGroup="mode"
                filterCount={filterCount}
                onClick={this.changeFilter}
                checked={thermostatFilters.mode[filter] === true}
                percentage={percentage}
              >
                <SettingIndicator reset={false} setting={filter} />
              </FilterRow>
            );
          })}
        </div>
      </div>
    );
  }

  renderFanSetting() {
    const { thermostatFilters } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Fan Setting</div>
        <div>
          {fanMode.map((item, index) => {
            const { filter, filterDisplay } = item;
            const filterCount = this.props.thermostatFilterCounts.fan_mode[filter];
            const percentage = this.calculatePercent(filterCount);
            const key = `${filter}${index}`;
            return (
              <FilterRow
                key={key}
                filter={filter}
                filterDisplay={filterDisplay}
                filterGroup="fan_mode"
                filterCount={filterCount}
                onClick={this.changeFilter}
                checked={thermostatFilters.fan_mode[filter] === true}
                percentage={percentage}
              />
            );
          })}
        </div>
      </div>
    );
  }

  renderState() {
    const { thermostatFilters } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Thermostat State</div>
        <div>
          {states.map((item, index) => {
            const { filter, filterDisplay } = item;
            const filterCount = this.props.thermostatFilterCounts.state[filter];
            const percentage = this.calculatePercent(filterCount);
            const key = `${filter}${index}`;
            return (
              <FilterRow
                key={key}
                filter={filter}
                filterDisplay={filterDisplay}
                filterGroup="state"
                filterCount={filterCount}
                onClick={this.changeFilter}
                checked={thermostatFilters.state[filter] === true}
                percentage={percentage}
              >
                <DemandIndicator active={true} demand="state" disabled={false} setting={filter} />
              </FilterRow>
            );
          })}
        </div>
      </div>
    );
  }

  renderDemands() {
    const { thermostatFilters } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Demands</div>
        <div>
          {demand.map((item, index) => {
            const { filter, filterDisplay } = item;
            const filterCount = this.props.thermostatFilterCounts.demand[filter];
            const percentage = this.calculatePercent(filterCount);
            const key = `${filter}${index}`;
            return (
              <FilterRow
                key={key}
                filter={filter}
                filterDisplay={filterDisplay}
                filterGroup="demand"
                filterCount={filterCount}
                onClick={this.changeFilter}
                checked={thermostatFilters.demand[filter] === true}
                percentage={percentage}
              >
                <DemandIndicator active={true} demand={filter} disabled={false} />
              </FilterRow>
            );
          })}
        </div>
      </div>
    );
  }

  renderBuildingSection() {
    const { thermostatFilters } = this.props;
    const buttonLarge = 'filter-section__button filter-section__button--long';
    const buttonLargeSelected = `${buttonLarge} filter-section__button--selected`;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Building Section</div>
        <div className="filter-section__button-set">
          {buildingSection.map((item, index) => {
            const { filter, filterDisplay } = item;
            const key = `${filter}${index}`;
            return (
              <button
                key={key}
                className={thermostatFilters.building_section[filter] ? buttonLargeSelected : buttonLarge}
                id={filter}
                onClick={(e) => this.toggleButton(e, 'building_section')}
              >
                {filterDisplay}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  renderDirection() {
    const buttonSmall = 'filter-section__button filter-section__button--small-square';
    const buttonSmallSelected = `${buttonSmall} filter-section__button--selected`;
    const { thermostatFilters } = this.props;

    return (
      <div className="filter-section">
        <div className="filter-section__title">Direction</div>
        <div className="filter-section__button-set">
          <div className="filter-section__button-row">
            {rowOne.map((item, index) => {
              const { filter, filterDisplay } = item;
              const key = `${filter}${index}`;
              return (
                <button
                  key={key}
                  className={thermostatFilters.direction[filter] ? buttonSmallSelected : buttonSmall}
                  id={filter}
                  onClick={(e) => this.toggleButton(e, 'direction')}
                >
                  {filterDisplay}
                </button>
              );
            })}
          </div>
          <div className="filter-section__button-row">
            {rowTwo.map((item, index) => {
              const { filter, filterDisplay } = item;
              const key = `${filter}${index}`;
              return (
                <button
                  key={key}
                  className={thermostatFilters.direction[filter] ? buttonSmallSelected : buttonSmall}
                  id={filter}
                  onClick={(e) => this.toggleButton(e, 'direction')}
                >
                  {filterDisplay}
                </button>
              );
            })}
          </div>
          <div className="filter-section__button-row">
            {rowThree.map((item, index) => {
              const { filter, filterDisplay } = item;
              const key = `${filter}${index}`;
              return (
                <button
                  key={key}
                  className={thermostatFilters.direction[filter] ? buttonSmallSelected : buttonSmall}
                  id={filter}
                  onClick={(e) => this.toggleButton(e, 'direction')}
                >
                  {filterDisplay}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderBuildingSection()}
        {this.renderDirection()}
        {this.renderConnectionState()}
        {this.renderThermostatMode()}
        {this.renderState()}
        {this.renderFanSetting()}
        {this.renderDemands()}
      </React.Fragment>
    );
  }
}

FilterSections.propTypes = {
  thermostatFilterCounts: PropTypes.shape({
    mode: PropTypes.shape({
      auto: PropTypes.number,
      auxHeatOnly: PropTypes.number,
      cool: PropTypes.number,
      eco: PropTypes.number,
      heat: PropTypes.number,
      heat_cool: PropTypes.number,
      off: PropTypes.number,
    }),
    fan_mode: PropTypes.shape({
      auto: PropTypes.number,
      off: PropTypes.number,
      on: PropTypes.number,
    }),
    connection_state: PropTypes.shape({
      offline: PropTypes.number,
      online: PropTypes.number,
      reset: PropTypes.number,
    }),
    state: PropTypes.shape({
      aux_heat: PropTypes.number,
      cool: PropTypes.number,
      heat: PropTypes.number,
      off: PropTypes.number,
    }),
    demand: PropTypes.shape({
      is_fan_running: PropTypes.number,
      is_occupied: PropTypes.number,
    }),
  }).isRequired,
  filteredThermostatCount: PropTypes.number.isRequired,
  updateFilters: PropTypes.func.isRequired,
  thermostatFilters: PropTypes.shape({
    connection_state: PropTypes.shape({
      online: PropTypes.bool,
      off: PropTypes.bool,
      offline: PropTypes.bool,
    }).isRequired,
    demand: PropTypes.shape({
      is_occupied: PropTypes.bool,
      is_fan_running: PropTypes.bool,
    }).isRequired,
    direction: PropTypes.shape({
      north: PropTypes.bool,
      north_east: PropTypes.bool,
      north_west: PropTypes.bool,
      west: PropTypes.bool,
      east: PropTypes.bool,
      south_east: PropTypes.bool,
      south_west: PropTypes.bool,
      south: PropTypes.bool,
    }),
    fan_mode: PropTypes.shape({
      auto: PropTypes.bool,
      off: PropTypes.bool,
      on: PropTypes.bool,
    }),
    building_section: PropTypes.shape({
      bottom: PropTypes.bool,
      middle: PropTypes.bool,
      top: PropTypes.bool,
    }),
    mode: PropTypes.shape({
      auto: PropTypes.bool,
      auxHeatOnly: PropTypes.bool,
      cool: PropTypes.bool,
      eco: PropTypes.bool,
      heat: PropTypes.bool,
      heat_cool: PropTypes.bool,
      off: PropTypes.bool,
    }),
    searchValue: PropTypes.string.isRequired,
    state: PropTypes.shape({
      aux_heat: PropTypes.bool,
      cool: PropTypes.bool,
      heat: PropTypes.bool,
      off: PropTypes.bool,
    }),
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    thermostatFilterCounts: state.thermostatReducer.thermostatFilterCounts,
    filteredThermostatCount: state.thermostatReducer.filteredThermostatCount,
    thermostatFilters: state.thermostatReducer.thermostatFilters,
  };
}

const mapDispatchToProps = {
  updateFilters: ThermostatActions.updateFilters,
};

const ConnectedFilterSections = connect(mapStateToProps, mapDispatchToProps)(FilterSections);
export { ConnectedFilterSections };
